const masks = [
    { label: 'SSN ###-##-####', value: '/\\d/,/\\d/,/\\d/,-,/\\d/,/\\d/,-,/\\d/,/\\d/,/\\d/,/\\d/' },
    { label: 'Phone (333) 567-6768', value: '(,/[1-9]/,/\\d/,/\\d/,), ,/\\d/,/\\d/,/\\d/,-,/\\d/,/\\d/,/\\d/,/\\d/' },
    { label: 'Zipcode 12345-1234', value: '/\\d/,/\\d/,/\\d/,/\\d/,/\\d/,-,/\\d/,/\\d/,/\\d/,/\\d/' },
];

export default masks;
